/* eslint-disable react/prop-types */
import { Button } from '@material-ui/core';
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  EditButton,
  DeleteButton,
  DateField,
  usePermissions,
} from 'react-admin';
import axios from 'axios';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import ListActions from '../../components/ListActions';
import UnitsFilter from '../../components/UnitsFilter';
import TourUnits from './TourUnits';

const UnitsList = (props) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  const generateScorm = async (record) => {
    const token = localStorage.getItem('access_token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    };
    // eslint-disable-next-line react/prop-types
    const response = await axios.post(
      `${process.env.REACT_APP_API}/wraps`,
      {
        id: record.id,
        name: record.name,
        courseId: record.courseId.id,
        scormPath: record.scormId.filePath,
        licenseId: record.courseId.licenseId.id,
        licenseStatus: record.courseId.licenseId.status,
        licenseStartDate: record.courseId.licenseId.startDate,
        licenseEndDate: record.courseId.licenseId.endDate,
      },
      config
    );

    const url = URL.createObjectURL(
      new Blob([response.data], { type: 'application/zip' })
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${record.name}`);
    document.body.appendChild(link);
    link.click();
  };

  const ButtonField = ({ record }) => (
    <Button
      data-testId="generate-button"
      onClick={() => generateScorm(record)}
      color="primary"
      variant="outlined"
      startIcon={<AutorenewIcon />}
    >
      {translate('custom.general.generate')}
    </Button>
  );

  return (
    <List
      {...props}
      sort={{ field: 'updatedAt', order: 'DESC' }}
      actions={
        <ListActions
          {...props}
          tourConfig={TourUnits({ translate })}
          hideFilters
        />
      }
      filters={<UnitsFilter />}
    >
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" label={translate('custom.general.name')} />
        <TextField source="status" label={translate('custom.general.status')} />
        <TextField
          label={translate('custom.units.courseName')}
          source="courseId.name"
        />
        <TextField
          label={translate('custom.scorms.titleSingular')}
          source="scormId.fileName"
        />
        <DateField
          label={translate('custom.general.createdAt')}
          source="createdAt"
          showTime
        />
        <DateField
          label={translate('custom.general.updatedAt')}
          source="updatedAt"
          showTime
        />
        <ButtonField />
        <EditButton data-testid="Units-edit" />
        {permissions === 'ADMIN' && <DeleteButton data-testid="Units-delete" />}
      </Datagrid>
    </List>
  );
};

export default UnitsList;
